import { ApiEndpoints } from "../models/ApiEndpoints";
import { FullUserInformation } from "../models/UserInformation";
import { useApiGet, ApiGetHook } from "@skanska/vsa-client-auth";

export function useGetMe(): ApiGetHook<FullUserInformation> {
  return useApiGet<FullUserInformation>(ApiEndpoints.UsersMe);
}
